import { Header } from '~/widgets/Header/Header';
import { Map } from '~/widgets/Map/Map';
import { FreeParking } from '~/widgets/FreeParking/FreeParking';
//import { Payment } from '~/widgets/Payment/ui/Payment';
import { AnimatePresence, motion } from 'framer-motion';
import { StartDate } from '~/widgets/StartDate/ui/StartDate';
import { useMainPageStore } from '~/pages/MainPage/model/useMainPageStore';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { useEffect, useRef, useState } from 'react';
// import { useNavigate } from '@remix-run/react';
// import { useGetCurrentUser } from '~/shared/hooks/useGetCurrentUser';
import { useGetParking } from '~/shared/hooks/useGetParkings';
import { Button } from '~/shared/ui/Button/Button';
import { FreeParkingContent } from '~/widgets/FreeParking/FreeParkingContent/FreeParkingContent';
import { useGetParkingById } from '~/shared/hooks/useGetParkingById';
import { RentBegin } from '~/pages/HourlyRent/RentBegin/ui/RentBegin';
import { useCreateRentSession } from '~/shared/hooks/useCreateSession';
import { useGetActiveRents } from '~/shared/hooks/useGetActiveRents';
//import Navigation from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { useGetCars } from '~/shared/hooks/useGetCars';
import { Portal } from '~/shared/ui/Portal/Portal';
import { Popup } from '~/entities/Popup/Popup';
import Inter from '../../../../public/icons/entry.svg?react';
import { cvaIcon } from '~/shared/styles/IconStyles';
import clsx from 'clsx';
import useWindowDimensions from '~/shared/hooks/useWindowDimentions';
import { ProfilePage } from '~/pages/ProfilePage/ui/ProfilePage';
import { BootScreen } from '~/widgets/BootScreen/BootScreen';
import { useYandexMaps } from '~/widgets/Map/lib/useYandexMaps';
import { LoadingSpinner } from '~/shared/ui/LoadingSpinner/LoadingSpinner';
//import { RegistrationCodePage } from '~/pages/RegistrationCodePage/ui/RegistrationCodePage';

//import useMeasure from 'react-use-measure';
//import { useGetParkingById } from '~/shared/hooks/useGetParkingById';

export const MainPage = () => {
  const reactify = useYandexMaps();
  const sheetRef = useRef();
  const { height } = useWindowDimensions();
  //  const galleryRef = useRef();
  const [rent, setIsRent] = useState(false);
  const [showGallery, setShowGallery] = useState(false);

  const { parkingList, isLoading } = useGetParking();

  const onCreateSuccess = () => {
    setIsRent(true);
    setIsOpen('none');
  };
  const { create, isLoading: isLoadingCreate } =
    useCreateRentSession(onCreateSuccess);

  const { rents } = useGetActiveRents();
  const { data: cars } = useGetCars();

  const { state, actions } = useMainPageStore();
  const { isOpen, startDateIsOpen, parkingID, search } = state;
  const { openPlaces, openPayment, setIsOpen, setSearch, setStartDateIsOpen } =
    actions;

  const { data } = useGetParkingById(parkingID);

  const [openDescription, setOpenDescription] = useState(true);

  const closeStartDate = () => {
    setStartDateIsOpen(false);
    setIsOpen('places');
  };

  useEffect(() => {
    if (isOpen !== 'menu') {
      setIsOpen('boot');
    }
  }, []);

  useEffect(() => {
    if (isOpen === 'places' || isOpen === 'payment') {
      document.body.style.overflow = 'hidden';
    }
  }, [isOpen]);

  // useEffect(() => {
  //   if (parkingList?.length) {
  //     openPlaces(parkingList[0].id);
  //   }
  // }, [parkingList?.length]);

  useEffect(() => {
    if (rents?.length) {
      setIsRent(true);

      const newPlace = {
        address: rents[0]?.parking_space.parking.address,
        lat: rents[0]?.parking_space.parking.lat,
        lon: rents[0]?.parking_space.parking.lon,
      };
      setSearch(newPlace);
    }
  }, [rents?.length]);

  if (isLoading) {
    return (
      <div>
        <BootScreen />
      </div>
    );
  }

  return (
    <>
      <AnimatePresence>
        <div className={'max-h-screen overflow-clip'}>
          <Header places={[]} totalProfit={0} />
          {reactify ? (
            <Map
              reactify={reactify}
              setSearch={setSearch}
              openPlaces={openPlaces}
              main={true}
              markers={parkingList}
              searchLocation={search ? [search.lon, search.lat] : undefined}
              searchZoom={search ? search.zoom : undefined}
            />
          ) : (
            <LoadingSpinner
              text="Загружаем карту..."
              className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"
            />
          )}

          <BottomSheet
            expandOnContentDrag
            open={isOpen === 'places'}
            ref={sheetRef}
            scrollLocking={false}
            defaultSnap={() => 360}
            snapPoints={() => [360, height - 236, height]}
            onDismiss={() => setIsOpen('none')}
            onSpringStart={(event) => {
              if (event.type == 'OPEN') {
                setShowGallery(true);
              } else if (event.type == 'CLOSE') {
                setShowGallery(false);
              }
            }}
            header={
              <FreeParking
                isScrollingHandler={() => false}
                id={parkingID}
                parking={data}
                close={setIsOpen}
                openStartDate={setStartDateIsOpen}
                openPayment={openPayment}
                openDescription={openDescription}
                setOpenDescription={setOpenDescription}
              />
            }
            footer={
              openDescription ? (
                <div className="flex justify-center px-2.4 py-1.2 [&_button]:w-full before:absolute before:-mt-4.2 before:right-0 before:left-0 before:w-full before:h-3 before:bg-gradient-to-b from-[#25233100] to-[#252331]">
                  <Button
                    variant={'primary'}
                    size={'common'}
                    disabled={data?.free_spaces == 0}
                    onClick={() => setIsOpen('rent')}>
                    Арендовать
                  </Button>
                </div>
              ) : null
            }
            sibling={
              showGallery ? (
                <AnimatePresence>
                  <motion.div
                    initial={{ opacity: 0, translateY: 300 }}
                    animate={{ opacity: 1, translateY: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    className="absolute w-full z-[31]"
                    style={{
                      bottom: 0,
                      height: 'calc((var(--rsbs-overlay-h) - 30vh)*3.3',
                      maxHeight: height,
                    }}>
                    <Swiper
                      modules={[Pagination]}
                      pagination={{ clickable: true }}
                      threshold={10}
                      slidesPerView={1}
                      className={clsx(
                        'relative w-full max-h-[25rem]',
                        '[&_.swiper-pagination-clickable]:h-1 [&_.swiper-pagination-clickable]:w-full [&_.swiper-pagination-clickable]:flex [&_.swiper-pagination-clickable]:px-2.1',
                        '[&_.swiper-pagination-bullet]:border-none [&_.swiper-pagination-bullet]:rounded-[1.2rem] [&_.swiper-pagination-bullet]:h-0.3',
                        '[&_.swiper-pagination-bullet]:relative [&_.swiper-pagination-bullet]:bottom-2.2 [&_.swiper-pagination-bullet]:w-full',
                        '[&_.swiper-pagination-bullet:not(.swiper-pagination-bullet-active)]:opacity-50',
                        '[&_.swiper-pagination-bullet]:bg-white'
                      )}>
                      <SwiperSlide>
                        <img
                          className="object-cover w-full max-h-[25rem]"
                          src={'/images/parking-mock.png'}
                          alt=""
                          style={{
                            height: '',
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="object-cover w-full max-h-[25rem]"
                          src={'/images/parking-mock.png'}
                          alt=""
                          style={{
                            height: '',
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          className="object-cover w-full max-h-[25rem]"
                          src={'/images/parking-mock.png'}
                          alt=""
                          style={{
                            height: '',
                          }}
                        />
                      </SwiperSlide>
                    </Swiper>
                  </motion.div>
                </AnimatePresence>
              ) : null
            }>
            <div
            //  ref={sheetBoundsRef}
            >
              <FreeParkingContent
                openDescription={openDescription}
                isScrollingHandler={() => false}
                id={parkingID}
                parking={data}
                openStartDate={setStartDateIsOpen}
                openPayment={openPayment}
              />
            </div>
          </BottomSheet>

          {startDateIsOpen && <StartDate close={closeStartDate} />}
          {isOpen === 'places' && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className={
                'absolute top-0 left-0 w-full h-full z-20 bg-[#000017CC]'
              }></motion.div>
          )}

          {rent && rents?.length ? (
            <div className="fixed w-full [&_div]:overflow-visible bottom-2 left-0 right-0 z-[10]">
              <Swiper
                threshold={10}
                slidesPerView={'auto'}
                spaceBetween={8}
                className="[&_div]:overflow-visible !px-1.6">
                {rents.map((rent, index) => (
                  <SwiperSlide
                    key={index}
                    className={
                      rents?.length > 1
                        ? 'max-w-[calc(100vw-5.6rem)]'
                        : 'max-w-[calc(100vw-3.2rem)]'
                    }>
                    <RentBegin
                      rent={rent}
                      onPay={() => {
                        setIsOpen('payment');
                      }}
                      onExit={() => {
                        //setPaid(false);
                        //   setIsOpen('none');
                      }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ) : null}
        </div>
        {isOpen == 'rent' && (
          <Portal>
            <Popup
              formPopup
              className="text-left"
              title={'15 минут бесплатно'}
              description={
                data?.name +
                ' · ' +
                data?.address +
                '<br/> Подъезжайте к парковке, шлагбаум откроется автоматически.'
              }
              open={isOpen == 'rent'}
              onClose={() => setIsOpen('places')}
              button={{
                text: 'Открыть въезд',
                isLoading: isLoadingCreate,
                action: () => create({ id: parkingID, auto_id: cars[0].id }),
                icon: <Inter className={cvaIcon({ iconSize: 'secondary' })} />,
              }}></Popup>
          </Portal>
        )}
        {isOpen == 'menu' && (
          <Portal opacity={false}>
            <ProfilePage toMainPage={false} />
          </Portal>
        )}
        {/* {isOpen == 'boot' && (
          <Portal opacity={false}>
            <motion.div
              key={Number(isOpen == 'boot')}
              initial={{ opacity: 0, translateY: 30 }}
              animate={{ opacity: 1, translateY: 0 }}
              exit={{ opacity: 0, translateY: 30 }}
              transition={{ ease: 'easeOut', duration: 0.3 }}>
              <BootScreen />
            </motion.div>
          </Portal>
        )} */}
      </AnimatePresence>
    </>
  );
};
